import { render } from "./SupportUs.vue?vue&type=template&id=ae7c5eaa&scoped=true"
import script from "./SupportUs.vue?vue&type=script&lang=js"
export * from "./SupportUs.vue?vue&type=script&lang=js"

import "./SupportUs.vue?vue&type=style&index=0&id=ae7c5eaa&scoped=true&lang=css"

import exportComponent from "/github/workspace/timmies-helper-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7c5eaa"]])

export default __exports__